// Centralized data-testid values so QA + code stay in sync.
export const IDS = {
  loginPage: "login-page",
  loginGoogleBtn: "login-google-btn",
  callbackPage: "callback-page",
  dashboardPage: "patient-dashboard",
  quizStartBtn: "quiz-start-btn",
  quizNextBtn: "quiz-next-btn",
  quizSubmitBtn: "quiz-submit-btn",
  quizProgress: "quiz-progress",
  insightsPage: "insights-page",
  dynamicsPage: "dynamics-page",
  fieldPage: "field-page",
  libraryPage: "library-page",
  libraryItem: (id) => `library-item-${id}`,
  readerPage: "reader-page",
  profilePage: "profile-page",
  logoutBtn: "logout-btn",
  unlockPage: "unlock-page",
  unlockInput: "unlock-code-input",
  unlockSubmit: "unlock-submit-btn",
  restorePurchasesBtn: "restore-purchases-btn",
  checkoutPage: "checkout-page",
  checkoutPayBtn: "checkout-pay-btn",
  purchaseCompletePage: "purchase-complete-page",
  adminPage: "admin-page",
  adminGenerateBtn: "admin-generate-code-btn",
  adminLookupInput: "admin-lookup-input",
  adminLookupBtn: "admin-lookup-btn",
  navLink: (id) => `nav-link-${id}`,
  archetypeCard: (name) => `archetype-card-${name}`,
};

export const HOME = { emergentLink: "emergent-link" };
